import { ActionButton, Icon } from '@fluentui/react';
import { baseUrlUser } from '../../../../constants/url.constant';
import ChatButton from '../../../common/views/ChatButton';
import { Utils } from '../../../common/views/Utils';
import { ProductUtils } from '../../../products/views/ProductUtils';
import { OrderModel } from '../../models/OrderModel';
import OrderTrackingView from '../shared/OrderTrackingView';
import { OrderUtils } from '../shared/OrderUtils';

export type OrderItemProps = {
    order: OrderModel;
    onDetail: (order: OrderModel) => void;
    onInvoiceDetail: (id: string) => void;
}

export default function OrderItemCompactView({ order, onDetail, onInvoiceDetail }: OrderItemProps) {
    let url = order.product ? ProductUtils.getImageUrl(baseUrlUser, order.product.picture) : "";
    const total = OrderUtils.getTotal(order);

    const isMobile = window.innerWidth <= 500;
    const width3 = Utils.getColumnWidth(3);
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width9 = Utils.getColumnWidth(9);
    const width4D = Utils.getColumnWidth(4, 4, 5);
    const width8D = Utils.getColumnWidth(8, 8, 7);

    const onProductDetail = () => {
        if (order.product && order.product.link) {
            window.open(order.product.link, "_blank");
        } else {
            alert("Product link not available.");
        }

    }
    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width4 + " left"}>
                <ChatButton />
            </div>

            <div className={width4 + " center pt-10 font-bold"}>
                $ {total.toFixed(2)}
            </div>

            <div className={width4 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "NumberedListTextMirrored" }}
                    onClick={() => onDetail(order)}
                >Detail</ActionButton>
            </div>
        </div>;
    }

    const invoiceIdText = () => {
        return <div
            onClick={() => onInvoiceDetail(order.invoiceId ?? "")}
            className="pt-5 cursor limit-lines one-line gray"
            style={{ textDecoration: "underline", fontSize: "x-small" }}
        >{order.invoiceId}</div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="ms-Grid-row ph-5" style={{ minHeight: isMobile ? 0 : 110 }}>
                <div className={width3 + " left pointer"} onClick={onProductDetail} style={{ paddingRight: 0 }}>
                    {OrderUtils.image(url, order.qty, 80, 0, false)}
                </div>
                <div className={width9}>
                    <div className="ms-Grid-row">
                        <div className={width8D}>
                            {OrderUtils.ProductInfo(order)}
                        </div>

                        <div className={width4D + " right"}>
                            <div>{OrderUtils.getStatusText(order.status)}</div>
                            <div className="pt-5 gray limit-lines one-line font-smaller">
                                {Utils.formatShortDate(order.orderDate)}
                            </div>
                            {!Utils.isNullOrEmpty(order.invoiceId) && invoiceIdText()}
                        </div>
                    </div>

                    {OrderUtils.ShowTracking(order) && <div className="pt-15">
                        <OrderTrackingView trackings={order.trackings} />
                    </div>}
                </div>
            </div>
            <div className="pt-10">
                {actionRow()}
            </div>
        </div>
    </div>;
}